export const ADMIN_ROLE = "admin"
export const USER_ROLE = "user"